<template>
  <div class="app_container container">
    <Loading />
    <Header />
    <router-view />
  </div>
</template>

<script>

import Loading from './components/loading';
import Header from './components/header.vue';

export default {
  name: "App",
  components: {
    Loading,
    Header,
  },
  data() {
    return {
      appTitle: process.env.VUE_APP_TITLE,
      appVersion: process.env.VUE_APP_VERSION,
    };
  },
  methods: {

  },
  computed: {

  },
  beforeDestroy() {

  },
  created() {

  },
  mounted() {
    const commentText = ` App: ${this.appTitle}; Version: ${this.appVersion} `;
    const comment = document.createComment(commentText);

    const existingComment = Array.from(document.body.childNodes).find(node =>
      node.nodeType === Node.COMMENT_NODE &&
      node.nodeValue.trim() === commentText.trim()
    );

    if (!existingComment) {
      document.body.appendChild(comment);
    }
  }
};
</script>
